var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wf-hero-banner-with-cta mt-3 my-project-cover" },
    [
      _vm.projectDetails.boardDetails.coverPhoto
        ? _c("picture", [
            _c("img", {
              staticClass: "responsive-image background-image",
              attrs: {
                src: _vm.projectDetails.boardDetails.coverPhoto,
                alt: _vm.projectDetails.boardDetails.title || ""
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "wf-hero-banner-with-cta-content" }, [
          _c("h5", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.projectDetails.boardDetails.title) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.projectDetails.boardDetails.description) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _vm.userRole
            ? _c("div", { staticClass: "wf-hero-banner-with-cta-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.editProject }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["myProject.Project.EditPage.Title"]
                      )
                    )
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }